/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
// import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Translate from "../../i18n/Translate";

// import { I18nContext } from "../../context/I18nProvider";

import Flags from "./components/Flags";

import { MenuIcon, SocialMedia, ArrowLeft } from "../../components/icons/";
import AdsImage from "../../assets/images/static/menu__content__ads.png";
import AdsImage2x from "../../assets/images/static/menu__content__ads@2x.png";
import color from "../../assets/scss/variables/colors.module.scss";

const Menu = ({
  isMenuOpen,
  setIsMenuOpen,
  handleMenuClick,
  elementInview,
}) => {
  // const { language } = useContext(I18nContext);

  const { t } = useTranslation();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  return (
    <section className={isMenuOpen ? "menu openend" : "menu closed"}>
      <div
        className={
          elementInview ? "menu__container isVisible" : "menu__container"
        }
      >
        <span></span>
        <div className="menu__container__button">
          <p>
            <Translate langkey="globals.close" />
          </p>
          <MenuIcon
            setIsMenuOpen={setIsMenuOpen}
            isMenuOpen={isMenuOpen}
            handleMenuClick={handleMenuClick}
          />
        </div>
      </div>

      <div className="menu__content">
        {/* Banderas */}
        <div className="menu__content__flags">
          <Flags setIsMenuOpen={setIsMenuOpen} isMenuOpen={isMenuOpen} />
        </div>

        {/* Rutas */}
        <nav className="menu__content__links">
          <Link
            to={`${t("routes.home")}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Translate langkey="routes.home-text" />
          </Link>

          <Link
            to={`${t("routes.about")}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Translate langkey="routes.institutional-text" />
          </Link>

          <Link
            to={`${t("routes.psports")}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Translate langkey="routes.psports-text" />
          </Link>

          <Link
            to={`${t("routes.contact")}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Translate langkey="routes.contact-text" />
          </Link>
        </nav>

        {/* Image */}
        <a
          href="https://towertravel.staging.portinos.com/rugby/"
          rel="noreferrer"
          target="_blank"
          className="menu__content__ads"
        >
          <picture>
            <source media="(max-width: 992px)" srcSet={AdsImage2x} />
            <source media="(min-width: 992px)" srcSet={AdsImage} />
            <img src={AdsImage} alt="ads" />
          </picture>

          <p>
            <ArrowLeft />
          </p>
        </a>

        {/* Redes */}
        <div className="menu__content__socials">
          <SocialMedia
            fill={color.colorPrimario}
            background="transparent"
            fb // facebook
            ig // instagram
            tt // twitter
          />
        </div>
      </div>
    </section>
  );
};

export default Menu;
